import SEO from "../components/SEO";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="terms-page">
      <SEO
        title="Terms of Use | Indiana Accident Aid"
        description="The terms governing your use of Indiana Accident Aid, a free attorney-matching service for Indiana accident victims."
      />
      <h1 className="font-display font-black text-4xl sm:text-5xl text-forest mb-6">Terms of Use</h1>
      <p className="text-sm text-forest/60 mb-10">Last updated: {new Date().getFullYear()}</p>

      <div className="space-y-6 text-forest/80 leading-relaxed text-base">
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Acceptance of Terms</h2>
          <p>
            By accessing or using Indiana Accident Aid (the &ldquo;Site&rdquo;), you agree to these
            Terms of Use. If you do not agree, please do not use the Site.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">What We Do</h2>
          <p>
            Indiana Accident Aid is a free informational and attorney-matching service. We are not a
            law firm and do not provide legal advice or representation. We connect visitors with
            independent attorneys for free, no-obligation consultations. See our{" "}
            <a href="/disclaimer" className="text-terracotta font-semibold hover:underline">Legal Disclaimer</a>{" "}
            for important details.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">No Attorney-Client Relationship</h2>
          <p>
            Using the Site or submitting a form does not create an attorney-client relationship. Such a
            relationship is formed only when you and an attorney sign a written agreement.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Your Responsibilities</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Provide accurate information when you contact us.</li>
            <li>Use the Site only for lawful purposes.</li>
            <li>Understand that legal deadlines are strict and time-sensitive — act promptly.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Intellectual Property</h2>
          <p>
            Content on this Site is provided for general information and is owned by or licensed to
            Indiana Accident Aid. You may not reproduce or distribute it without permission.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Disclaimers &amp; Limitation of Liability</h2>
          <p>
            The Site and its content are provided &ldquo;as is,&rdquo; without warranties of any kind.
            To the fullest extent permitted by law, Indiana Accident Aid is not liable for any damages
            arising from your use of the Site or reliance on its content, or from any legal services
            provided by independent attorneys.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Governing Law</h2>
          <p>These Terms are governed by the laws of the State of Indiana, without regard to conflict-of-law principles.</p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Changes</h2>
          <p>
            We may update these Terms at any time. Continued use of the Site after changes constitutes
            acceptance of the revised Terms.
          </p>
        </section>
      </div>
    </div>
  );
}
